import axios from 'axios';
import { SALES_BASE_URL, CRM_API_BASE_URL, AUTH_API_BASE_URL, ACCOUNTS_API_BASE_URL } from '../constants/api.js';

export const TOKEN_KEY = 'crm_token';

export const tokenStore = {
  get:    () => localStorage.getItem(TOKEN_KEY),
  set:    (t) => localStorage.setItem(TOKEN_KEY, t),
  remove: () => localStorage.removeItem(TOKEN_KEY),
};

// ─── Token Interceptors ──────────────────────────────────────────────────────
const setupInterceptors = (instance) => {
  instance.interceptors.request.use((config) => {
    const token = tokenStore.get();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      if (status === 401) {
        tokenStore.remove();
        const errorMessage = error.response?.data?.error || 'Session expired. Please log in again.';
        sessionStorage.setItem('login_message', errorMessage);
        window.location.href = '/login';
      }
      if (error.response?.data) {
        const data = error.response.data;
        const err = new Error(data.error || data.message || `HTTP ${status}`);
        err.status = status;
        err.data = data;
        return Promise.reject(err);
      }
      return Promise.reject(error);
    }
  );
};

// ─── Axios instance for Auth (port 5003) ─────────────────────────────────────
export const authApiInstance = axios.create({
  baseURL: AUTH_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

// ─── Axios instance for Sales (port 5001) ────────────────────────────────────
export const salesApiInstance = axios.create({
  baseURL: SALES_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

// ─── Axios instance for CRM (port 5000) ──────────────────────────────────────
export const crmApiInstance = axios.create({
  baseURL: CRM_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

// ─── Axios instance for Accounts (port 5002) ─────────────────────────────────
export const accountsApiInstance = axios.create({
  baseURL: ACCOUNTS_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

setupInterceptors(authApiInstance);
setupInterceptors(salesApiInstance);
setupInterceptors(crmApiInstance);
setupInterceptors(accountsApiInstance);
